import * as z from "zod/v4";
import {
  CallDirection,
  CallState,
  RingingStrategy,
  UserCallAvailability,
  WebRTCCallState,
} from "./voice-types";

export const userCallAvailabilitySchema = z.enum([
  UserCallAvailability.AVAILABLE,
  UserCallAvailability.IN_CALL,
  UserCallAvailability.UNAVAILABLE,
]);

export const webRTCCallStateSchema = z.enum([
  WebRTCCallState.NEW,
  WebRTCCallState.TRYING,
  WebRTCCallState.REQUESTING,
  WebRTCCallState.RECOVERING,
  WebRTCCallState.RINGING,
  WebRTCCallState.ANSWERING,
  WebRTCCallState.EARLY,
  WebRTCCallState.ACTIVE,
  WebRTCCallState.HELD,
  WebRTCCallState.HANGUP,
  WebRTCCallState.DESTROY,
  WebRTCCallState.PURGE,
]);

export const callDirectionSchema = z.enum([
  CallDirection.INBOUND,
  CallDirection.OUTBOUND,
]);

export const callStateSchema = z.enum([
  CallState.RINGING,
  CallState.ACTIVE,
  CallState.CONNECTING,
  CallState.HANGUP,
]);

export const ringingStrategySchema = z.enum([
  RingingStrategy.ROUND_ROBIN,
  RingingStrategy.RING_TEAM,
]);
